import { render, staticRenderFns } from "./tab_menus.vue?vue&type=template&id=2fee92cc&scoped=true&"
import script from "./tab_menus.vue?vue&type=script&lang=js&"
export * from "./tab_menus.vue?vue&type=script&lang=js&"
import style0 from "./tab_menus.vue?vue&type=style&index=0&id=2fee92cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fee92cc",
  null
  
)

export default component.exports